import styled from "styled-components";

export const ContactFieldWrapper = styled.div`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;

  && > div {
    padding: 0;
  }
`;
